import { useEffect, useState } from 'react';

export const useGetBadge = <T,>(badges: T[]): T | null => {
  const [badge, setBadge] = useState<T | null>(null);

  useEffect(() => {
    if (badges.length > 0) {
      setBadge(badges[0]);
    } else {
      setBadge(null);
    }
  }, [badges]);

  return badge;
};
